import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Server_URL } from 'src/environments/environment';
import { environment } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root'
})
export class ProjectsService {
  public Data = new BehaviorSubject(null)

  constructor(private _HttpClient:HttpClient) { }

  GetProjects():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Project/Get`);
  }
  GetProjectsByid(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Project/GetById?Id=${id}`);
  }
  GetProjectsPaged(pager:any):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Project/GetPaged`,pager);
  }
  DeleteProject(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Project/Delete?id=${id}`);
  }

  CreateProject(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Project/Create`,data);
  }
  UpdateProject(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Project/Update`,data)
  }

  CreateProjectImage(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/ProjectImage/Create`,data);
  }
  GetProjectImages(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/ProjectImage/Get?projectId=${id}`);
  }

  DeleteProjectImages(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/ProjectImage/Delete?id=${id}`);
  }
  
}
